const BASE_URL = "https://fakestoreapi.com"

export {
    BASE_URL,
}